module.exports = __webpack_public_path__ + "img/file-lines-solid.2cdc6c4e.svg";